import type { RouteLocationRaw } from 'vue-router'
import { isNavigationFailure } from 'vue-router'

export function replaceWithResolvedRoute (router: any, location: RouteLocationRaw): Promise<unknown> {
  return router.replace(location).then((failure: unknown) => {
    if (isNavigationFailure(failure)) {
      return Promise.reject(failure)
    }
    return router.currentRoute?.value
  })
}
